import ShimmerContainer from '@alltrails/core/components/ShimmerContainer';
import type { JSX } from 'react';
import styles from './SearchLoading.module.scss';

type SearchLoadingProps = {
  repeatNum?: number;
};

const SearchLoading = ({ repeatNum = 3 }: SearchLoadingProps): JSX.Element => (
  <div className={styles.container}>
    {Array(repeatNum)
      .fill('')
      .map((_, idx) => (
        <ShimmerContainer key={`review-search-load-${idx}`} className={styles.reviewContainer}>
          <div className={styles.headerContentGroup}>
            <div className={styles.avatar} />
            <div className={styles.headerTextGroup}>
              <div className={styles.headerText1} />
              <div className={styles.headerText2} />
            </div>
          </div>
          <div className={styles.bodyGroup}>
            {[...Array(5)].map((_, index) => (
              <div key={index} className={styles.text} />
            ))}
          </div>
        </ShimmerContainer>
      ))}
  </div>
);
export default SearchLoading;
